import "./index.scss";

import Icon from "../../assets/Icon";
import { Link } from "react-router-dom";
import React from "react";
import Title from "./../Title";
import cuid from "cuid";

// Icon

const dateAdjust = text => {
  let date = text.split("-");
  return `${date[2]}/${date[1]}/${date[0]}`;
};

const createCard = (
  id,
  title,
  subTitle,
  theme,
  type,
  icon,
  name,
  date,
  description,
  vacations,
  absence,
  targetAudience,
  maxHeightExpanded,
  sizeBreaker
) => {
  if (type === "person") {
    return (
      <div className={`card ${theme} compact`}>
        <i className={`fa fa-user icon-card`} />
        <Title text={name} type={`CARD-COMPACT-TITLE`} theme={theme} />
        <Title text={date} type={`CARD-COMPACT-SUBTITLE`} theme={theme} />
      </div>
    );
  } else if (type === "compact") {
    return (
      <Link to={`/service/${id}`} className={`card ${theme} ${type}`}>
        <i className={`${icon} icon-card`} />
        <Title text={title} type={`CARD-COMPACT-TITLE`} theme={theme} />
        <Title text={subTitle} type={`CARD-COMPACT-SUBTITLE`} theme={theme} />
      </Link>
    );
  } else if (type === "absence") {
    return (
      <Link to={`/Absence/${id}`} className={`card ${theme} ${type} compact`}>
        <i className={`fa fa-user icon-card`} />
        <Title text={name} type={`CARD-COMPACT-TITLE`} theme={theme} />
        <Title text={date} type={`CARD-COMPACT-SUBTITLE`} theme={theme} />
      </Link>
    );
  } else if (type === "absence-expanded") {
    return (
      <div
        className={`card ${theme} ${type} expanded`}
        style={
          maxHeightExpanded ? { maxHeight: `${maxHeightExpanded}px` } : null
        }
      >
        <i className={`fa fa-user icon-card`} />
        <div className="expanded-text-container">
          <div className="expanded-title">
            <Title text={name} type={`CARD-EXPANDED-TITLE`} theme={theme} />
          </div>
          <div className="expanded-text">
            {vacations ? vacations.map((value, index)=> {
              return <div className="expanded-description">
                <Title
                    text={`Exercício ${value.exercicio}`}
                    type={`CARD-EXPANDED-TITLE-ALT`}
                    theme={theme}
                />
                <ol>
                  {value.feriasPeriodos.map(vac => (
                      <li key={cuid()}>
                        {`De ${dateAdjust(vac.dataInicio)} até ${dateAdjust(
                            vac.dataFim
                        )}`}{" "}
                        <p>{`Quantidade de dias: ${vac.qtdeDias}`}</p>
                        <br/>
                      </li>
                  ))}
                </ol>
              <br/> </div>
            }) : null}
            {absence.length > 0 ? (
              <div className="expanded-audience">
                <Title
                  text={"Afastamento"}
                  type={`CARD-EXPANDED-TITLE-ALT`}
                  theme={theme}
                />
                <ol>
                  {absence.map(ab => (
                    <li key={cuid()}>
                      {`De ${dateAdjust(ab.inicio)} até ${dateAdjust(ab.fim)}`}
                      {ab.afastamento ? (
                        <p>Motivo: {ab.afastamento.motivo}</p>
                      ) : null}
                      <br />
                    </li>
                  ))}
                </ol>
              </div>
            ) : null}
          </div>
        </div>
        <Link to="/Absence" className="close">
          <Icon type="close" />
        </Link>
      </div>
    );
  } else if (type === "expanded") {
    return (
      <div
        className={`card ${theme} ${type}`}
        style={
          maxHeightExpanded ? { maxHeight: `${maxHeightExpanded}px` } : null
        }
      >
        <i className={`${icon} icon-card`} />
        <div className="expanded-text-container">
          <div className="expanded-title">
            <Title text={title} type={`CARD-EXPANDED-TITLE`} theme={theme} />
            <Title
              text={subTitle}
              type={`CARD-EXPANDED-SUBTITLE`}
              theme={theme}
            />
          </div>
          <div className="expanded-text">
            {description ? (
              <div className="expanded-description">
                <Title
                  text={"Descrição"}
                  type={`CARD-EXPANDED-TITLE-ALT`}
                  theme={theme}
                />
                <p>{description}</p>
              </div>
            ) : null}
            {targetAudience.length > 0 ? (
              <div className="expanded-audience">
                <Title
                  text={"Público alvo"}
                  type={`CARD-EXPANDED-TITLE-ALT`}
                  theme={theme}
                />
                {targetAudience.map(audience => (
                  <p key={cuid()}>- {audience}</p>
                ))}
              </div>
            ) : null}
          </div>
        </div>
        <Link to="/" className="close">
          <Icon type="close" />
        </Link>
      </div>
    );
  }
};

const index = ({
  id,
  title,
  subTitle,
  theme,
  type,
  icon,
  name,
  date,
  description,
  vacations,
  absence,
  targetAudience,
  maxHeightExpanded,
  sizeBreaker
}) => {
  return createCard(
    id,
    title,
    subTitle,
    theme,
    type,
    icon,
    name,
    date,
    description,
    vacations,
    absence,
    targetAudience,
    maxHeightExpanded,
    sizeBreaker
  );
};

export default index;
